import React, { useMemo } from 'react';
import { BaseCell } from '../../../../../../../components';
import data from '../../../../pages/RegrasDePreco/lib/data';
import { RuleDataItem } from '../../lib/service';

const RulePageTablePriceCell = ({ rulePriceType }: RuleDataItem) => {
  const renderLabel = useMemo(() => {
    return data.rulePriceTypeDataItem.find(({ value }) => value === rulePriceType)?.label;
  }, [rulePriceType]);

  if (!rulePriceType) return <BaseCell>--</BaseCell>;
  return <BaseCell>{renderLabel}</BaseCell>;
};

export default RulePageTablePriceCell;
